export default {
  "kol_accepted": {
    "HK": "已確認，歡迎！",
    "TW": "已確認，歡迎！",
    "ar_SA": "تم القبول. مرحبًا!",
    "de_DE": "Angenommen. Willkommen!",
    "en_US": "Accepted. Welcome!",
    "es_ES": "Aceptado. ¡Te damos la bienvenida!",
    "fr_FR": "Accepté. Bienvenue !",
    "hi_IN": "Accepted. Welcome!",
    "in_ID": "Disetujui. Selamat datang!",
    "ja_JP": "受け入れました。 いらっしゃいませ！",
    "ko_KR": "수락됨. 환영!",
    "ms_MY": "Diterima. Selamat datang!",
    "pt_PT": "Aceito. Boas-vindas!",
    "ru_RU": "Принято. Добро пожаловать!",
    "th_TH": "ตอบรับแล้ว ยินดีต้อนรับ!",
    "tr_TR": "Kabul edildi. Hoş geldin!",
    "vi_VN": "Đã chấp nhận. Xin chào!",
    "zh_CN": "有效，欢迎！"
  },
  "kol_account_id": {
    "HK": "輸入你的遊戲內ID",
    "TW": "輸入您的遊戲內ID",
    "ar_SA": "أدخل المُعرِّف داخل اللعبة الخاص بك",
    "de_DE": "Gib deine Account-ID im Spiel ein",
    "en_US": "Enter your account ID in the game",
    "es_ES": "Ingresa la ID de tu cuenta en el juego",
    "fr_FR": "Saisissez votre ID de compte en jeu",
    "hi_IN": "Enter your account ID in the game",
    "in_ID": "Masukkan ID Game kamu",
    "ja_JP": "ゲーム内でアカウントIDを入力",
    "ko_KR": "게임에서 계정 ID를 입력하세요.",
    "ms_MY": "Masukkan ID dalam permainan anda",
    "pt_PT": "Insira a ID da sua conta no jogo",
    "ru_RU": "Введите свой игровой ID",
    "th_TH": "กรุณาใส่ ID ในเกมของคุณ",
    "tr_TR": "Oyun İçi Kimliğini Gir",
    "vi_VN": "Nhập ID Trò Chơi của bạn",
    "zh_CN": "输入您游戏内的ID"
  },
  "kol_becoming": {
    "HK": "恭喜你成為PUBG MOBILE俱樂部建立者，請儲存你的海報並推廣給粉絲",
    "TW": "恭喜您成為PUBG MOBILE俱樂部的建立者，請儲存您的海報並推廣給粉絲",
    "ar_SA": "تهانينا! أصبحت من مؤسسي نادي PUBG MOBILE. احفظ ملصقك وأرسله إلى معجبيك.",
    "de_DE": "Glückwunsch! Du bist jetzt der Gründer deines eigenen PUBG MOBILE Clubs. Speichere dein Poster und verbreite es unter deinen Fans.",
    "en_US": "Congratulations on becoming a Club Founder in PUBG MOBILE! Save your poster and promote it to your fans.",
    "es_ES": "Felicidades por convertirte en fundador del club en PUBG MOBILE. Guarda tu póster y promociónalo con tus fans.",
    "fr_FR": "Félicitations, vous avez fondé votre club PUBG MOBILE ! Enregistrez votre affiche et diffusez-la auprès de vos fans.",
    "hi_IN": "Congratulations on becoming a Club Founder in PUBG MOBILE! Save your poster and promote it to your fans.",
    "in_ID": "Selamat telah menjadi Pendiri Klub di PUBG MOBILE! Simpan postermu dan kirimkan kepada para penggemar.",
    "ja_JP": "PUBG MOBILE のクラブ ファウンダーになりました。おめでとうございます! ポスターを保存して、ファンに宣伝しましょう。",
    "ko_KR": "PUBG MOBILE의 클럽 창립자가 되신 것을 축하합니다! 포스터를 저장하고 팬에게 홍보하세요.",
    "ms_MY": "Tahniah kerana menjadi Pengasas Kelab dalam PUBG MOBILE! Simpan poster anda dan promosikannya kepada peminat anda.",
    "pt_PT": "Parabéns por se tornar fundador do seu PUBG MOBILE CLUB! Salve seu pôster e promova seu CLUB para seus fãs.",
    "ru_RU": "Поздравляем! Теперь вы в списке основателей клубов PUBG MOBILE. Сохраните свой плакат и поделитесь им с поклонниками.",
    "th_TH": "ยินดีด้วยคุณได้เป็นผู้ก่อตั้งคลับของ PUBG MOBILE แล้ว! บันทึกโปสเตอร์และส่งให้แฟนคลับของคุณกันเลย",
    "tr_TR": "Bir PUBG MOBILE Kulüp Kurucusu olduğun için tebrikler! Afişini kaydet ve hayranlarına gönder.",
    "vi_VN": "Xin chúc mừng bạn đã trở thành Người Sáng Lập Câu Lạc Bộ trong PUBG MOBILE! Hãy lưu hình ảnh và quảng bá điều này cho fan của bạn.",
    "zh_CN": "恭喜您成为PUBG MOBILE俱乐部创建者，保存您的海报并将其推广给粉丝"
  },
  "kol_bind": {
    "HK": "綁定",
    "TW": "綁定",
    "ar_SA": "ربط",
    "de_DE": "Verbinden",
    "en_US": "Connect",
    "es_ES": "Conectar",
    "fr_FR": "Connecter",
    "hi_IN": "Connect",
    "in_ID": "Tautkan",
    "ja_JP": "接続",
    "ko_KR": "연결하다",
    "ms_MY": "Pautkan",
    "pt_PT": "Conectar",
    "ru_RU": "Привязать",
    "th_TH": "ผูก",
    "tr_TR": "Bağla",
    "vi_VN": "Liên kết",
    "zh_CN": "绑定"
  },
  "kol_bind_fail": {
    "HK": "綁定失敗，請重試",
    "TW": "綁定失敗，請重試",
    "ar_SA": "فشل الربط. يُرجى المحاولة مرة أخرى.",
    "de_DE": "Verbindung fehlgeschlagen, bitte versuche es erneut.",
    "en_US": "Connection failed, please try again",
    "es_ES": "Conexión fallida. Inténtalo de nuevo",
    "fr_FR": "Échec de la connexion. Veuillez réessayer.",
    "hi_IN": "Connection failed, please try again",
    "in_ID": "Gagal menautkan. Coba lagi.",
    "ja_JP": "接続に失敗しました。もう一度お試しください",
    "ko_KR": "연결하지 못했습니다. 다시 시도해 주세요.",
    "ms_MY": "Pautan gagal. Sila cuba lagi.",
    "pt_PT": "Falha na conexão, tente de novo",
    "ru_RU": "Ошибка привязки. Повторите попытку.",
    "th_TH": "ผูกไม่สำเร็จ กรุณาลองใหม่อีกครั้ง",
    "tr_TR": "Bağlama başarısız. Lütfen tekrar dene.",
    "vi_VN": "Liên kết thất bại. Vui lòng thử lại.",
    "zh_CN": "绑定失败，请重试"
  },
  "kol_bind_more": {
    "HK": "綁定更多社交媒體帳號",
    "TW": "綁定更多社群媒體帳號",
    "ar_SA": "ربط المزيد من حسابات التواصل الاجتماعي",
    "de_DE": "Verknüpfe mehr Social-Media-Accounts",
    "en_US": "Connect more social media accounts",
    "es_ES": "Conecta más cuentas de redes sociales",
    "fr_FR": "Connecter d'autres comptes de réseaux sociaux",
    "hi_IN": "Connect more social media accounts",
    "in_ID": "Tautkan beberapa akun media sosial",
    "ja_JP": "より多くのソーシャル メディア アカウントを接続する",
    "ko_KR": "더 많은 소셜 미디어 계정 연결",
    "ms_MY": "Sambung lebih banyak akaun media sosial",
    "pt_PT": "Conecte mais contas de rede social",
    "ru_RU": "Привязать дополнительные учетные записи в соцсетях",
    "th_TH": "เชื่อมต่อบัญชีโซเชียลมีเดียเพิ่ม",
    "tr_TR": "Daha fazla sosyal medya hesabı bağla",
    "vi_VN": "Liên kết thêm tài khoản mạng xã hội",
    "zh_CN": "绑定更多社媒账号"
  },
  "kol_bind_suc": {
    "HK": "綁定成功！",
    "TW": "綁定成功！",
    "ar_SA": "تم الربط بنجاح!",
    "de_DE": "Verbindung erfolgreich",
    "en_US": "Connection successful",
    "es_ES": "Conexión correcta",
    "fr_FR": "Connexion établie",
    "hi_IN": "Connection successful",
    "in_ID": "Penautan berhasil!",
    "ja_JP": "接続成功",
    "ko_KR": "연결 성공",
    "ms_MY": "Berjaya dipautkan!",
    "pt_PT": "Conexão realizada com sucesso",
    "ru_RU": "Успешная привязка!",
    "th_TH": "ผูกสำเร็จ!",
    "tr_TR": "Başarıyla bağlandı!",
    "vi_VN": "Liên kết thành công!",
    "zh_CN": "绑定成功！"
  },
  "kol_bind_title": {
    "HK": "已有200多位PUBG MOBILE KOL將社交媒體帳號綁定到PUBG MOBILE俱樂部",
    "TW": "已有200多位PUBG MOBILE KOL將社群媒體帳號綁定到PUBG MOBILE俱樂部",
    "ar_SA": "أكثر من 200 مُؤثِّر لدى PUBG MOBILE قاموا بربط صفحاتهم بالفعل بنادي PUBG MOBILE.",
    "de_DE": "Mehr als 200 PUBG MOBILE-Influencer haben ihre Seiten bereits mit dem PUBG MOBILE CLUB verbunden.",
    "en_US": "More than 200 PUBG MOBILE Influencers already connected their pages to PUBG MOBILE CLUB.",
    "es_ES": "Más de 200 influencers de PUBG MOBILE ya conectaron sus páginas a PUBG MOBILE CLUB.",
    "fr_FR": "Plus de 200 influenceurs PUBG MOBILE ont déjà connecté leur page au PUBG MOBILE CLUB.",
    "hi_IN": "More than 200 PUBG MOBILE Influencers already connected their pages to PUBG MOBILE CLUB.",
    "in_ID": "Lebih dari 200 KOL PUBG MOBILE telah menautkan akun media sosial mereka ke PUBG MOBILE CLUB.",
    "ja_JP": "すでに 200 人を超える PUBG MOBILE インフルエンサーが自分のページを PUBG MOBILE CLUB に接続しています。",
    "ko_KR": "200명 이상의 PUBG MOBILE 인플루언서가 이미 자신의 페이지를 PUBG MOBILE CLUB에 연결했습니다.",
    "ms_MY": "Lebih daripada 200 Pempengaruh PUBG MOBILE sudah menghubungkan halaman mereka dengan Kelab PUBG MOBILE.",
    "pt_PT": "Mais de 200 Influenciadores do PUBG MOBILE já conectaram suas páginas ao PUBG MOBILE CLUB.",
    "ru_RU": "К PUBG MOBILE CLUB привязали свои учетные записи уже более 200 инфлюенсеров PUBG MOBILE.",
    "th_TH": "อินฟลูเอนเซอร์ PUBG MOBILE มากกว่า 200 คน ได้เชื่อมต่อหน้าเพจของพวกเขากับ PUBG MOBILE คลับแล้ว",
    "tr_TR": "200'den fazla PUBG MOBILE Fenomeni, sayfalarını PUBG MOBILE Kulüp ile ilişkilendirdi bile.",
    "vi_VN": "Hơn 200 KOL PUBG MOBILE đã liên kết tài khoản mạng xã hội vào Câu Lạc Bộ PUBG MOBILE.",
    "zh_CN": "已有200多个PUBG MOBILE KOL将其社媒账号绑定到PUBG MOBILE俱乐部"
  },
  "kol_cancel": {
    "HK": "取消",
    "TW": "取消",
    "ar_SA": "إلغاء",
    "de_DE": "Abbrechen",
    "en_US": "Cancel",
    "es_ES": "Cancelar",
    "fr_FR": "Annuler",
    "hi_IN": "Cancel",
    "in_ID": "Batalkan",
    "ja_JP": "キャンセル",
    "ko_KR": "취소",
    "ms_MY": "Batal",
    "pt_PT": "Cancelar",
    "ru_RU": "Отмена",
    "th_TH": "ยกเลิก",
    "tr_TR": "İptal",
    "vi_VN": "Hủy",
    "zh_CN": "取消"
  },
  "kol_club_invitation": {
    "HK": "邀請你成為俱樂部建立者",
    "TW": "邀請您成為俱樂部建立者",
    "ar_SA": "أنت مدعو لتصبح من مؤسسي النادي.",
    "de_DE": "CLUBGRÜNDER-EINLADUNG",
    "en_US": "CLUB FOUNDER INVITATION",
    "es_ES": "INVITACIÓN DE FUNDADOR DEL CLUB",
    "fr_FR": "INVITATION À DEVENIR UN FONDATEUR DU CLUB",
    "hi_IN": "CLUB FOUNDER INVITATION",
    "in_ID": "UNDANGAN PENDIRI KLUB",
    "ja_JP": "クラブ創設者招待状",
    "ko_KR": "클럽 창립자 초대",
    "ms_MY": "JEMPUTAN PENGASAS KELAB",
    "pt_PT": "CONVITE PARA FUNDADOR DE CLUB",
    "ru_RU": "ПРИГЛАШЕНИЕ СТАТЬ ОСНОВАТЕЛЕМ КЛУБА",
    "th_TH": "คำเชิญให้เป็นผู้ก่อตั้งคลับ",
    "tr_TR": "KULÜP KURUCULUĞU DAVETİ",
    "vi_VN": "MỜI NGƯỜI SÁNG LẬP CÂU LẠC BỘ",
    "zh_CN": "邀请您成为俱乐部创建者"
  },
  "kol_code_first": {
    "HK": "請先輸入你的邀請碼",
    "TW": "請先輸入您的邀請碼",
    "ar_SA": "يُرجى إدخال رمز دعوتك",
    "de_DE": "Bitte gib deinen Einladungscode ein",
    "en_US": "Please enter your invitation code",
    "es_ES": "Ingresa tu código de invitación",
    "fr_FR": "Saisissez votre code d'invitation",
    "hi_IN": "Please enter your invitation code",
    "in_ID": "Masukkan kode undanganmu",
    "ja_JP": "招待コードを入力してください",
    "ko_KR": "초대 코드를 입력하세요",
    "ms_MY": "Sila masukkan kod jemputan anda",
    "pt_PT": "Insira seu código de convite",
    "ru_RU": "Введите свой код приглашения.",
    "th_TH": "กรุณาใส่รหัสเชิญของคุณ",
    "tr_TR": "Lütfen davet kodunu gir",
    "vi_VN": "Hãy nhập mã mời của bạn",
    "zh_CN": "请先输入您的邀请码"
  },
  "kol_code_tip": {
    "HK": "你的邀請碼只能使用一次",
    "TW": "您的邀請碼只能使用一次",
    "ar_SA": "يمكن استخدام رمز الدعوة الخاص بك مرة واحدة فقط.",
    "de_DE": "Dein Einladungscode kann nur einmal verwendet werden.",
    "en_US": "Your invitation code can only be used once",
    "es_ES": "Tu código de invitación solo se puede usar una vez.",
    "fr_FR": "Votre code d'invitation ne peut être utilisé qu'une fois",
    "hi_IN": "Your invitation code can only be used once",
    "in_ID": "Kode undanganmu hanya dapat digunakan sekali",
    "ja_JP": "招待コードは一度しか使用できません",
    "ko_KR": "초대 코드는 한 번만 사용할 수 있습니다.",
    "ms_MY": "Kod jemputan anda hanya boleh digunakan sekali.",
    "pt_PT": "Seu convite só pode ser usado uma vez",
    "ru_RU": "Код приглашения можно использовать только один раз.",
    "th_TH": "รหัสเชิญของคุณสามารถใช้ได้เพียงครั้งเดียวเท่านั้น",
    "tr_TR": "Davet kodun sadece bir defa kullanılabilir.",
    "vi_VN": "Mã mời của bạn chỉ có thể sử dụng một lần.",
    "zh_CN": "您的邀请码只能使用一次"
  },
  "kol_coming_soon": {
    "HK": "PUBG MOBILE最新內置功能「俱樂部」即將上線！",
    "TW": "PUBG MOBILE最新內建功能「俱樂部」即將上線！",
    "ar_SA": "قريبًا نادي PUBG MOBILE، الميزة داخل اللعبة الأحدث!",
    "de_DE": "Das neueste Feature im Spiel, der PUBG MOBILE CLUB, erscheint bald!",
    "en_US": "PUBG MOBILE newest in-game feature - CLUB is coming online!",
    "es_ES": "¡La nueva función del juego de PUBG MOBILE, CLUB, estará disponible en línea!",
    "fr_FR": "Le club, la toute dernière fonctionnalité de PUBG MOBILE, fait son entrée !",
    "hi_IN": "PUBG MOBILE newest in-game feature - CLUB is coming online!",
    "in_ID": "Fitur dalam game terbaru di PUBG MOBILE - CLUB - segera hadir!",
    "ja_JP": "PUBG MOBILE の最新ゲーム内機能 - CLUB がオンラインに登場！",
    "ko_KR": "PUBG MOBILE의 최신 게임 내 기능인 CLUB이 온라인에 등장합니다!",
    "ms_MY": "Ciri dalam permainan terbaru Kelab PUBG MOBILE bakal tiba!",
    "pt_PT": "A mais nova função no jogo do PUBG MOBILE: o CLUBe está chegando!",
    "ru_RU": "В игре скоро появится новый функционал PUBG MOBILE CLUB!",
    "th_TH": "พบกับ PUBG MOBILE คลับ ฟีเจอร์ใหม่ล่าสุดภายในเกมได้เร็วๆ นี้!",
    "tr_TR": "En son oyun içi özellik olan PUBG MOBILE Kulüp yakında geliyor!",
    "vi_VN": "Tính năng mới nhất trong PUBG MOBILE, Câu Lạc Bộ sắp ra mắt!",
    "zh_CN": "PUBG MOBILE最新内置功能-俱乐部即将上线！"
  },
  "kol_community_rules": {
    "HK": "請確保同步後的內容符合社群規則，否則將觸發內容過濾規則",
    "TW": "請確保同步的內容符合社群規則，否則會觸發內容過濾規則",
    "ar_SA": "يرجى التأكد من أن المحتوى الذي تمت مزامنته متوافق مع قواعد المجتمع ، وإلا سيتم تشغيل قواعد تصفية المحتوى.",
    "de_DE": "Bitte stelle sicher, dass die synchronisierten Inhalte mit den Community-Regeln vereinbar sind, da sonst Inhaltsfilterungsregeln auslöst werden.",
    "en_US": "Please make sure that the synchronized content complies with the community rules, or it will trigger the content filtering rules.",
    "es_ES": "Asegúrate de que el contenido sincronizado cumpla con las reglas de la comunidad. De lo contrario, se activarán las reglas de filtrado de contenido.",
    "fr_FR": "Assurez-vous que le contenu synchronisé respecte les règles de communauté, sous peine de déclencher les règles de filtrage de contenu.",
    "hi_IN": "Please make sure that the synchronized content complies with the community rules, or it will trigger the content filtering rules.",
    "in_ID": "Harap pastikan bahwa konten yang disinkronkan mematuhi aturan komunitas, atau hal tersebut akan memicu aturan pemfilteran konten.",
    "ja_JP": "同期されたコンテンツがコミュニティ ルールに準拠していることを確認してください。準拠していない場合、コンテンツ フィルタリング ルールがトリガーされます。",
    "ko_KR": "동기화된 콘텐츠가 커뮤니티 규칙을 준수하는지 확인하세요. 그렇지 않으면 콘텐츠 필터링 규칙이 트리거됩니다.",
    "ms_MY": "Sila pastikan kandungan yang disegerakkan mematuhi peraturan komuniti atau ia akan mencetuskan peraturan penapisan kandungan.",
    "pt_PT": "Certifique-se de que o conteúdo sincronizado segue as regras da comunidade, ou ativará as regras de filtro de conteúdo.",
    "ru_RU": "Убедитесь, что синхронизируемый контент соответствует правилам сообщества, чтобы он не попал под фильтрацию.",
    "th_TH": "กรุณาตรวจสอบว่าเนื้อหาที่ถูกอัปเดตสอดคล้องกับกฎของคอมมูนิตี้หรือไม่ มิฉะนั้น เงื่อนไขการกรองเนื้อหาจะถูกเปิดใช้งาน",
    "tr_TR": "Senkronize edilen içeriğin topluluk kurallarıyla uyumlu olduğundan emin olmalısın, aksi takdirde içerik filtreleme kurallarını devreye sokabilir.",
    "vi_VN": "Hãy đảm bảo nội dung được đồng bộ hóa đáp ứng các quy tắc cộng đồng để không kích hoạt quá trình lọc nội dung.",
    "zh_CN": "请确保同步后的内容符合社区守则，否则将触发内容过滤规则"
  },
  "kol_congratulations": {
    "HK": "恭喜你！身為PUBG MOBILE社群的KOL，我們誠邀你參與體驗PUBG MOBILE最新內置功能：PUBG MOBILE俱樂部。你將有機會成為頭一批俱樂部建立者。",
    "TW": "恭喜您！我們誠邀PUBG MOBILE社群KOL的您，參與體驗PUBGM最新的內建功能：PUBG MOBILE俱樂部。您將有機會成為首批俱樂部的建立者。",
    "ar_SA": "تهانينا! بصفتك واحدًا من المؤثرين موضع التقدير في مجتمع PUBG MOBILE، فأنت مدعو إلى المشاركة في أحدث ميزة داخل اللعبة من PUBG MOBILE، وهي نادي PUBG MOBILE. ستحظى بفرصة أن تصبح واحدًا من مؤسسي النادي الأوائل.",
    "de_DE": "Glückwunsch! Als geschätzter Influencer der PUBG MOBILE-Community laden wir dich ein, am neuesten Feature im Spiel von PUBG MOBILE teilzunehmen – dem PUBG MOBILE CLUB. Du hast die Chance, einer der ersten CLUBgründer zu werden.",
    "en_US": "Congratulations! As a valued influencer of PUBG MOBILE community, you are invited to participate in the PUBG MOBILE newest IN-GAME feature - PUBG MOBILE CLUB. You will have the chance to become one of the first CLUB Founders.",
    "es_ES": "¡Felicidades! Por ser un preciado influencer de la comunidad de PUBG MOBILE, te invitamos a participar en la función más nueva de PUBG MOBILE: PUBG MOBILE CLUB. Tendrás la oportunidad de convertirte en uno de los primeros fundadores de un CLUB.",
    "fr_FR": "Félicitations ! En tant qu'influenceur estimé au sein de la communauté de PUBG MOBILE, nous vous invitons à participer à la toute dernière fonctionnalité de PUBG MOBILE : le PUBG MOBILE CLUB. Vous aurez la chance de devenir l'un des premiers fondateurs de clubs.",
    "hi_IN": "Congratulations! As a valued influencer of PUBG MOBILE community, you are invited to participate in the PUBG MOBILE newest IN-GAME feature - PUBG MOBILE CLUB. You will have the chance to become one of the first CLUB Founders.",
    "in_ID": "Selamat! Sebagai KOL di komunitas PUBG MOBILE, kami ingin mengundang kamu untuk menguji fitur bawaan terbaru kami: PUBG MOBILE CLUB, serta peluang untuk menjadi salah seorang Pendiri Klub pertama.",
    "ja_JP": "おめでとう！ PUBG MOBILE コミュニティの貴重なインフルエンサーとして、PUBG MOBILE の最新のゲーム内機能である PUBG MOBILE CLUB に参加するよう招待されています。 最初の CLUB 創設者の 1 人になるチャンスがあります。",
    "ko_KR": "축하해요! PUBG MOBILE 커뮤니티의 소중한 인플루언서로서 PUBG MOBILE의 최신 게임 내 기능인 PUBG MOBILE CLUB에 참여하도록 초대합니다. 귀하는 최초의 CLUB 창립자가 될 수 있는 기회를 갖게 됩니다.",
    "ms_MY": "Tahniah, sebagai seorang pempengaruh yang dihargai komuniti PUBG MOBILE, anda dijemput untuk menyertai ciri dalam permainan PUBG MOBILE terkini - Kelab PUBG MOBILE. Anda akan berpeluang untuk menjadi salah seorang Pengasas Kelab yang pertama.",
    "pt_PT": "Parabéns! Como influenciador(a) importante para a comunidade do PUBG MOBILE, estamos convidando você para participar da mais nova função do PUBG MOBILE, o PUBG MOBILE CLUB. Você terá a chance de se tornar um dos primeiros Fundadores de CLUBe.",
    "ru_RU": "Поздравляем! Вы ценный инфлюенсер сообщества PUBG MOBILE, поэтому получаете приглашение опробовать новейший игровой функционал — PUBG MOBILE CLUB. Вы можете войти в число первых основателей клубов.",
    "th_TH": "ยินดีด้วย! ในฐานะอินฟลูเอนเซอร์ที่ทรงคุณค่าของคอมมูนิตี้ PUBG MOBILE คุณได้รับเชิญให้เข้าร่วมเป็นส่วนหนึ่งของฟีเจอร์เกมล่าสุดของ PUBG MOBILE - PUBG MOBILE คลับ และคุณยังมีโอกาสที่จะได้เป็นหนึ่งในผู้ก่อตั้งคลับกลุ่มแรกอีกด้วย",
    "tr_TR": "Tebrikler! PUBG MOBILE topluluğunda değerli bir fenomen olduğun için PUBG MOBILE oyun içi özelliği PUBG MOBILE Kulüp daveti aldın. İlk Kulüp Kuruculardan biri olma fırsatına sahip olacaksın.",
    "vi_VN": "Xin chúc mừng! Là một người có sức ảnh hưởng quan trọng trong cộng đồng PUBG MOBILE, bạn được mời tham gia tính năng mới nhất trong trò chơi PUBG MOBILE: Câu Lạc Bộ PUBG MOBILE. Bạn sẽ có cơ hội trở thành một trong những Người Sáng Lập Câu Lạc Bộ đầu tiên.",
    "zh_CN": "恭喜您！ 作为PUBG MOBILE社区的KOL，我们邀请您参与最新内置功能-PUBG MOBILE俱乐部体验。 您将有机会成为第一批俱乐部创建者。"
  },
  "kol_connected_one_id": {
    "HK": "請務必填寫自己使用的遊戲ID；你的俱樂部只能綁定一個ID。",
    "TW": "請務必填寫自己使用的遊戲ID；您的俱樂部只能綁定一個ID。",
    "ar_SA": "يُرجى التأكد من إدخال مُعرِّف اللعبة الخاص بك. يمكن ربط النادي الخاص بك بمُعرِّف واحد فقط.",
    "de_DE": "Bitte stelle sicher, dass du deine eigene ID eingibst. Dein CLUB kann nur mit einer ID verbunden sein.",
    "en_US": "Please be sure to enter the ID of your own. Your club can only be connected to one ID.",
    "es_ES": "Asegúrate de ingresar tu propia ID. Tu club solo puede estar conectado a una ID.",
    "fr_FR": "Veillez à bien saisir votre ID. Votre club ne peut être connecté qu'à un seul ID.",
    "hi_IN": "Please be sure to enter the ID of your own. Your club can only be connected to one ID.",
    "in_ID": "Pastikan untuk memasukkan ID Anda sendiri. Klub Anda hanya dapat terhubung ke satu ID.",
    "ja_JP": "必ずご自身のIDを入力してください。 クラブは 1 つの ID にのみ接続できます。",
    "ko_KR": "반드시 본인의 ID를 입력하세요. 클럽은 하나의 ID에만 연결할 수 있습니다.",
    "ms_MY": "Sila pastikan anda memasukkan ID permainan anda sendiri. Kelab anda hanya boleh dipautkan dengan satu ID.",
    "pt_PT": "Insira a sua própria ID do jogo. Seu clube só pode ser conectado a uma ID.",
    "ru_RU": "Убедитесь, что вводите именно свой игровой ID. Клуб может быть привязан только к одному идентификатору.",
    "th_TH": "กรุณาใส่ Game ID ของคุณ คลับของคุณสามารถผูกได้กับ ID เดียวเท่านั้น",
    "tr_TR": "Lütfen kendi oyun Kimliğini girdiğinden emin ol. Kulübün sadece bir Kimliğe bağlanabilir.",
    "vi_VN": "Hãy chắc chắn nhập ID trò chơi của bạn. Câu Lạc Bộ của bạn chỉ có thể liên kết với 1 ID.",
    "zh_CN": "请务必填写自己使用的游戏ID，您的俱乐部只能绑定一个ID。"
  },
  "kol_contact": {
    "HK": "如有任何疑問或建議，請聯絡：",
    "TW": "如有任何疑問或建議，請聯繫：",
    "ar_SA": "لأي أسئلة واقتراحات، يُرجى التواصل:",
    "de_DE": "Wenn du Fragen oder Anregungen hast, wende dich bitte an:",
    "en_US": "Any questions or suggestions, please contact :",
    "es_ES": "Para cualquier pregunta o sugerencia, contacta a:",
    "fr_FR": "Pour toute question ou suggestion, veuillez contacter :",
    "hi_IN": "Any questions or suggestions, please contact :",
    "in_ID": "Untuk pertanyaan dan saran, hubungi:",
    "ja_JP": "ご質問やご提案がございましたら、次までご連絡ください。",
    "ko_KR": "질문이나 제안 사항이 있으면 다음으로 연락하십시오.",
    "ms_MY": "Untuk sebarang pertanyaan dan cadangan, sila hubungi:",
    "pt_PT": "Se você tiver qualquer pergunta ou sugestão, entre em contato:",
    "ru_RU": "С вопросами и предложениями обращайтесь по адресу",
    "th_TH": "หากมีข้อสงสัยหรือคำแนะนำเพิ่มเติม กรุณาติดต่อ:",
    "tr_TR": "Soruların ve önerilerin için lütfen şurayla iletişim kur:",
    "vi_VN": "Nếu có bất kỳ ý kiến hoặc đề xuất nào, hãy liên hệ:",
    "zh_CN": "如有任何疑问或建议，请联系："
  },
  "kol_enter_id_first": {
    "HK": "請先儲存你的ID資訊",
    "TW": "請先儲存您的ID資訊",
    "ar_SA": "يُرجى حفظ معلومات المُعرِّف الخاص بك أولاً",
    "de_DE": "Bitte gib zuerst deine ID-Informationen ein.",
    "en_US": "Please enter your ID information first",
    "es_ES": "Ingresa primero la información de tu ID",
    "fr_FR": "Saisissez d'abord votre ID",
    "hi_IN": "Please enter your ID information first",
    "in_ID": "Harap masukkan informasi ID Anda terlebih dahulu",
    "ja_JP": "最初にID情報を入力してください",
    "ko_KR": "먼저 ID 정보를 입력하세요.",
    "ms_MY": "Sila simpan maklumat ID anda dahulu",
    "pt_PT": "Insira as informações da sua ID",
    "ru_RU": "Сначала сохраните данные своего ID.",
    "th_TH": "กรุณาบันทึกข้อมูล ID ของคุณก่อน",
    "tr_TR": "Lütfen önce Kimlik bilgilerini kaydet",
    "vi_VN": "Hãy lưu thông tin ID của bạn trước",
    "zh_CN": "请先保存您的ID信息"
  },
  "kol_first_founder": {
    "HK": "我已經成為首批俱樂部建立者",
    "TW": "我已經成為首批俱樂部建立者",
    "ar_SA": "أصبحت واحدًا من مؤسسي النادي الأوائل!",
    "de_DE": "Ich bin gerade einer der ersten Clubgründer geworden.",
    "en_US": "I've just become one of the first Club Founders!",
    "es_ES": "¡Acabo de convertirme en uno de los primeros fundadores de un club!",
    "fr_FR": "Je viens de devenir l'un des premiers fondateurs de club !",
    "hi_IN": "I've just become one of the first Club Founders!",
    "in_ID": "Saya baru saja menjadi salah seorang Pendiri Klub pertama!",
    "ja_JP": "私は最初のクラブ創設者の 1 人になりました!",
    "ko_KR": "저는 이제 막 최초의 클럽 창립자 중 한 명이 되었습니다!",
    "ms_MY": "Saya baru sahaja menjadi salah seorang Pengasas Kelab yang pertama!",
    "pt_PT": "Acabei de me tornar um dos primeiros Fundadores de CLUB!",
    "ru_RU": "Я в списке первых основателей клубов!",
    "th_TH": "ฉันกลายเป็นหนึ่งในผู้ก่อตั้งคลับกลุ่มแรกแล้ว!",
    "tr_TR": "İlk Kulüp Kurucularından biri oldum!",
    "vi_VN": "Tôi vừa trở thành một trong những Người Sáng Lập Câu Lạc Bộ đầu tiên!",
    "zh_CN": "我已经成为首批俱乐部创建者"
  },
  "kol_founder_benifits": {
    "HK": "只要成為俱樂部建立者，你可以：\r\n直接與遊戲中數百萬的潛在追蹤者建立長久關係。\r\n增加社交媒體的內容曝光率。\r\n使用強大的工具來幫助你組織比賽。\r\n獲得PUBG MOBILE官方認證。",
    "TW": "一旦成為俱樂部的建立者，您便可以：\r\n直接和遊戲中數百萬的潛在追蹤者建立長久的關係；\r\n增加社群媒體的內容曝光率；\r\n運用強大的工具來幫助您組織比賽；\r\n獲得PUBG MOBILE官方認證。",
    "ar_SA": "بمجرد أن تصبح واحدًا من مؤسسي النادي، فإنه بإمكانك:  \r\nتأسيس علاقات طويلة الأمد مع الملايين من المتابعين المحتملين مباشرةً داخل اللعبة.\r\nزيادة نسبة مشاهدة محتواك على مواقع التواصل الاجتماعي. \r\nاستخدام أدوات مفيدة للغاية لمساعدتك على تنظيم المباريات المخصصة.\r\nالاعتراف بك رسميًا من قِبل PUBG MOBILE.",
    "de_DE": "Als Clubgründer kannst du:\r\nLanglebige Beziehungen zu Millionen von potenziellen Followern im Spiel aufbauen.\r\nDie Präsenz deiner Inhalte in deinen Social-Media-Accounts erhöhen.\r\nMächtige Werkzeuge verwenden, die dir bei der Organisation deiner spielerdefinierten Matches helfen.\r\nOffiziell von PUBG Mobile verifiziert werden.",
    "en_US": "Once you become a Club Founder, you can:  \r\nBuild long-lasting relationships with millions of potential followers directly in the game.\r\nIncrease your social media exposure. \r\nUse powerful tools to help you organize Custom Matches.\r\nGet verified by PUBG MOBILE Official.",
    "es_ES": "Cuando te conviertas en fundador de un club, podrás: \r\nDesarrollar relaciones duraderas directamente con millones de posibles seguidores en el juego.\r\nAumentar la exposición del contenido de tus redes sociales. \r\nUsar herramientas potentes para ayudarte a organizar partidas personalizadas.\r\nObtener la verificación oficial de PUBG MOBILE.",
    "fr_FR": "En devenant fondateur de club, vous pourrez : \r\nBâtir des relations durables avec des millions d'abonnés potentiels, directement en jeu.\r\nAccroître votre notoriété sur les réseaux sociaux. \r\nUtiliser des outils puissants pour organiser des matchs personnalisés.\r\nObtenir la certification officielle PUBG MOBILE.",
    "hi_IN": "Once you become a Club Founder, you can:  \r\nBuild long-lasting relationships with millions of potential followers directly in the game.\r\nIncrease your social media exposure. \r\nUse powerful tools to help you organize Custom Matches.\r\nGet verified by PUBG MOBILE Official.",
    "in_ID": "Setelah menjadi Pendiri Klub, kamu akan bisa:\r\nMembangun hubungan yang erat dengan jutaan pengikut potensial di dalam game secara langsung.\r\nMeningkatkan eksposur media sosial kamu.\r\nMenggunakan alat bantu andal untuk membantumu mengelola Pertempuran Kustom.\r\nMendapatkan verifikasi dari PUBG MOBILE Official.",
    "ja_JP": "クラブの創設者になると、次のことができます。\r\nゲーム内で直接、何百万人もの潜在的なフォロワーと長期的な関係を築きましょう。\r\nソーシャル メディアでの露出を増やします。\r\n強力なツールを使用して、カスタム マッチを整理できます。\r\nPUBG MOBILE公式の認証を受ける。",
    "ko_KR": "클럽 창립자가 되면 다음을 수행할 수 있습니다.\r\r\n게임에서 직접 수백만 명의 잠재 팔로워와 오래 지속되는 관계를 구축하세요.\r\r\n소셜 미디어 노출을 늘리십시오.\r\r\n강력한 도구를 사용하여 커스텀 매치를 구성할 수 있습니다.\r\r\nPUBG MOBILE 공식 인증을 받으세요.",
    "ms_MY": "Selepas anda menjadi pengasas Kelab, anda boleh: \r\nMenjalinkan hubungan yang berkekalan dengan berjuta-juta pengikut berpotensi secara langsung dalam permainan.\r\nMeningkatkan pendedahan kandungan media sosial anda. \r\nMenggunakan alatan berkuasa untuk membantu anda menganjurkan Perlawanan Tersuai.\r\nMendapat pengesahan sah daripada PUBG MOBILE.",
    "pt_PT": "Depois de se tornar um fundador de CLUB, você pode:  \r\nConstruir relações duradouras diretamente com milhões de potenciais seguidores no jogo.\r\nAumentar a exposição do conteúdo da sua rede social.  \r\nUsar ferramentas poderosas para ajudar a organizar partidas personalizadas.\r\nReceber verificação do PUBG MOBILE Oficial.",
    "ru_RU": "Основав клуб, вы сможете:  \r\nСоздавать продолжительные связи с миллионами потенциальных подписчиков прямо в игре.\r\nУвеличить охват аудитории контента в социальных сетях. \r\nИспользовать эффективный инструментарий для создания пользовательских матчей.\r\nПолучить официальную верификацию от PUBG MOBILE.",
    "th_TH": "เมื่อคุณได้เป็นผู้ก่อตั้งคลับ คุณจะสามารถ: \r\nสร้างความสัมพันธ์แบบยั่งยืนกับผู้ติดตามที่มีศักยภาพภายในเกมมากกว่าหนึ่งล้านคน\r\nเพิ่มการรับรู้เนื้อหาโซเชียลมีเดียของคุณ\r\nใช้เครื่องมืออันทรงประสิทธิภาพ เพื่อช่วยคุณจัดการแมทช์แบบสร้างเอง\r\nได้รับการยืนยันตนอย่างเป็นทางการจาก PUBG MOBILE",
    "tr_TR": "Bir Kulüp Kurucusu olduğunda şunları yapabilirsin:  \r\nMilyonlarca potansiyel takipçiyle doğrudan oyun içinde uzun süreli ilişkiler kurabilirsin.\r\nSosyal medya içeriklerinin görünürlüğünü artırabilirsin. \r\nÖzel Maçlar düzenlemek için güçlü araçları kullanabilirsin.\r\nPUBG MOBILE tarafından resmî olarak onaylanabilirsin.",
    "vi_VN": "Khi trở thành Người Sáng Lập Câu Lạc Bộ, bạn có thể: \r\nXây dựng mối quan hệ lâu dài với hàng triệu người theo dõi tiềm năng trực tiếp trong trò chơi.\r\nTăng khả năng xuất hiện trên mạng xã hội.\r\nSử dụng các công cụ mạnh mẽ để giúp bạn tổ chức các Trận Đấu Tùy Chỉnh.\r\nĐược PUBG MOBILE xác minh chính thức.",
    "zh_CN": "一旦成为俱乐部创建者，您可以：\r\n直接与游戏中的数百万潜在关注者建立持久的关系。\r\n增加社交媒体的内容曝光率。\r\n使用强大的工具来帮助您组织比赛。\r\n获得PUBG MOBILE官方的认证。"
  },
  "kol_founder_benifits_1": {
    "HK": "直接與遊戲中數百萬的潛在追蹤者建立長久關係。",
    "TW": "直接和遊戲中數百萬的潛在追蹤者建立長久的關係。",
    "ar_SA": "تأسيس علاقات طويلة الأمد مع الملايين من المتابعين المحتملين مباشرةً داخل اللعبة.",
    "de_DE": "Langlebige Beziehungen zu Millionen von potenziellen Followern im Spiel aufbauen",
    "en_US": "Build long-lasting relationships with millions of potential followers in the game directly",
    "es_ES": "Desarrollar relaciones duraderas directamente con millones de posibles seguidores en el juego",
    "fr_FR": "Bâtir des relations durables avec des millions d'abonnés potentiels, directement en jeu",
    "hi_IN": "Build long-lasting relationships with millions of potential followers in the game directly",
    "in_ID": "Membangun hubungan yang erat dengan jutaan pengikut potensial di dalam game secara langsung",
    "ja_JP": "ゲーム内の何百万人もの潜在的なフォロワーと長期にわたる関係を直接構築する",
    "ko_KR": "게임에서 직접 수백만 명의 잠재적 팔로워와 오래 지속되는 관계를 구축하세요.",
    "ms_MY": "Jalinkan hubungan yang berkekalan dengan berjuta-juta pengikut berpotensi secara langsung dalam permainan.",
    "pt_PT": "Construir relações duradouras diretamente com milhões de potenciais seguidores no jogo",
    "ru_RU": "Создавать продолжительные связи с миллионами потенциальных подписчиков прямо в игре.",
    "th_TH": "สร้างความสัมพันธ์แบบยั่งยืนกับผู้ติดตามที่มีศักยภาพภายในเกมกว่าล้านคน",
    "tr_TR": "Milyonlarca potansiyel takipçiyle doğrudan oyun içinde uzun süreli ilişkiler kurabilirsin.",
    "vi_VN": "Xây dựng mối quan hệ lâu dài với hàng triệu người theo dõi tiềm năng trực tiếp trong trò chơi.",
    "zh_CN": "直接与游戏中的数百万潜在关注者建立持久的关系。"
  },
  "kol_founder_benifits_2": {
    "HK": "增加社交媒體內容的曝光率。",
    "TW": "增加社群媒體的內容曝光率。",
    "ar_SA": "زيادة نسبة مشاهدة محتواك على مواقع التواصل الاجتماعي.",
    "de_DE": "Die Präsenz deiner Inhalte in Social Media erhöhen",
    "en_US": "Increase content exposure of your social media",
    "es_ES": "Aumentar la exposición del contenido de tus redes sociales",
    "fr_FR": "Amplifier l'exposition du contenu de vos réseaux sociaux",
    "hi_IN": "Increase content exposure of your social media",
    "in_ID": "meningkatkan eksposure konten dari media sosial",
    "ja_JP": "ソーシャル メディアのコンテンツ露出を増やす",
    "ko_KR": "소셜 미디어의 콘텐츠 노출 증가",
    "ms_MY": "Meningkatkan pendedahan kandungan media sosial anda.",
    "pt_PT": "Aumentar a exposição do conteúdo da sua rede social",
    "ru_RU": "Увеличить охват аудитории контента для социальных сетей.",
    "th_TH": "เพิ่มการรับรู้เนื้อหาโซเชียลมีเดียของคุณ",
    "tr_TR": "Sosyal medya içeriklerinin görünürlüğünü artırabilirsin.",
    "vi_VN": "Tăng mức độ xuất hiện cho nội dung mạng xã hội của bạn.",
    "zh_CN": "增加社交媒体的内容曝光率。"
  },
  "kol_founder_benifits_3": {
    "HK": "使用強大的工具來幫助你組織比賽。",
    "TW": "運用強大的工具來幫助您組織比賽。",
    "ar_SA": "استخدام أدوات مفيدة للغاية لمساعدتك على تنظيم المباريات المخصصة.",
    "de_DE": "Mächtige Werkzeuge verwenden, die dir bei der Organisation deiner spielerdefinierten Matches helfen",
    "en_US": "Use powerful tools to help you organize custom matches",
    "es_ES": "Usar herramientas potentes para ayudarte a organizar partidas personalizadas",
    "fr_FR": "Utiliser des outils puissants pour vous aider à organiser des matchs personnalisés",
    "hi_IN": "Use powerful tools to help you organize custom matches",
    "in_ID": "menggunakan alat bantu andal untuk membantumu mengelola pertempuran",
    "ja_JP": "カスタムマッチの整理に役立つ強力なツールを使用する",
    "ko_KR": "강력한 도구를 사용하여 맞춤 일치를 구성하는 데 도움이 됩니다.",
    "ms_MY": "Menggunakan alatan berkuasa untuk membantu anda menganjurkan perlawanan tersuai.",
    "pt_PT": "Usar ferramentas poderosas para ajudar a organizar partidas personalizadas",
    "ru_RU": "Использовать эффективный инструментарий для создания пользовательских матчей.",
    "th_TH": "ใช้เครื่องมือทรงประสิทธิภาพ เพื่อช่วยจัดการแมทช์แบบสร้างเอง",
    "tr_TR": "Özel maçlar düzenlemek için güçlü araçları kullanabilirsin.",
    "vi_VN": "Sử dụng công cụ mạnh mẽ để giúp bạn tổ chức trận đấu tùy chỉnh.",
    "zh_CN": "使用强大的工具来帮助您组织比赛。"
  },
  "kol_founder_benifits_4": {
    "HK": "獲得PUBG MOBILE官方認證。",
    "TW": "獲得PUBG MOBILE官方認證。",
    "ar_SA": "الاعتراف بك رسميًا من قِبل PUBG MOBILE.",
    "de_DE": "Offiziell von PUBG MOBILE verifiziert werden",
    "en_US": "Get verification by PUBG MOBILE Official",
    "es_ES": "Obtener la verificación de PUBG MOBILE Oficial",
    "fr_FR": "Vous faire certifier par PUBG MOBILE Officiel",
    "hi_IN": "Get verification by PUBG MOBILE Official",
    "in_ID": "dan menjadi pengguna PUBG MOBILE terverifikasi",
    "ja_JP": "PUBG MOBILE 公式による認証を受ける",
    "ko_KR": "PUBG MOBILE 공식 인증 받기",
    "ms_MY": "Disahkan secara rasmi oleh PUBG MOBILE.",
    "pt_PT": "Receber verificação do PUBG MOBILE Oficial",
    "ru_RU": "Получить официальную верификацию от PUBG MOBILE.",
    "th_TH": "ได้รับการยืนยันตนอย่างเป็นทางการจาก PUBG MOBILE",
    "tr_TR": "PUBG MOBILE tarafından resmi olarak onaylanabilirsin.",
    "vi_VN": "Được PUBG MOBILE xác nhận chính thức.",
    "zh_CN": "获得PUBG MOBILE官方的认证。"
  },
  "kol_founder_benifits_title": {
    "HK": "只要成為俱樂部建立者，你可以",
    "TW": "一旦成為俱樂部的建立者，您便可以",
    "ar_SA": "بمجرد أن تصبح مؤسس النادي، فإنه بإمكانك",
    "de_DE": "Als Clubgründer kannst du",
    "en_US": "Once you become a Club Founder, you can",
    "es_ES": "Una vez que te conviertas en fundador de un club, podrás",
    "fr_FR": "En devenant fondateur de club, vous pourrez ",
    "hi_IN": "Once you become a Club Founder, you can",
    "in_ID": "Setelah menjadi Pendiri Klub, kamu bisa",
    "ja_JP": "クラブの創設者になると、次のことができます",
    "ko_KR": "클럽 창립자가 되면 다음을 수행할 수 있습니다.",
    "ms_MY": "Selepas anda menjadi Pengasas Kelab, anda boleh",
    "pt_PT": "Depois de se tornar um Fundador de CLUB, você pode",
    "ru_RU": "Как основатель клуба вы сможете",
    "th_TH": "เมื่อคุณได้เป็นผู้ก่อตั้งคลับ คุณจะสามารถ",
    "tr_TR": "Bir Kulüp Kurucusu olduğunda şunları yapabilirsin",
    "vi_VN": "Khi bạn trở thành Người Sáng Lập Câu Lạc Bộ, bạn có thể:",
    "zh_CN": "一旦成为俱乐部创建者，您可以"
  },
  "kol_go": {
    "HK": "下一步",
    "TW": "下一步",
    "ar_SA": "ذهاب",
    "de_DE": "OK",
    "en_US": "GO",
    "es_ES": "IR",
    "fr_FR": "ALLER",
    "hi_IN": "GO",
    "in_ID": "GO",
    "ja_JP": "行く",
    "ko_KR": "가다",
    "ms_MY": "MULA",
    "pt_PT": "IR",
    "ru_RU": "Перейти",
    "th_TH": "ไป",
    "tr_TR": "İNCELE",
    "vi_VN": "Tiếp theo",
    "zh_CN": "下一步"
  },
  "kol_input_code": {
    "HK": "輸入邀請碼",
    "TW": "輸入邀請碼",
    "ar_SA": "أدخل رمز الدعوة",
    "de_DE": "Einladungscode eingeben",
    "en_US": "Enter invitation code",
    "es_ES": "Ingresar código de invitación",
    "fr_FR": "Saisir le code d'invitation",
    "hi_IN": "Enter invitation code",
    "in_ID": "Masukkan kode undangan",
    "ja_JP": "招待コードを入力",
    "ko_KR": "초대 코드 입력",
    "ms_MY": "Masukkan kod jemputan",
    "pt_PT": "Inserir código de convite",
    "ru_RU": "Введите код приглашения",
    "th_TH": "กรุณาใส่รหัสเชิญ",
    "tr_TR": "Davet kodunu gir",
    "vi_VN": "Nhập mã mời",
    "zh_CN": "输入邀请码"
  },
  "kol_invalid_code": {
    "HK": "邀請碼無效，請檢查確認或聯絡我們",
    "TW": "無效邀請碼，請再次確認或聯繫我們",
    "ar_SA": "رمز دعوة غير صالح. يُرجى التحقق من الرمز أو الاتصال بنا.",
    "de_DE": "Ungültiger Einladungscode. Bitte überprüfe den Code oder kontaktiere uns.",
    "en_US": "Invalid invitation code. Please check the code or contact us.",
    "es_ES": "El código de invitación no es válido. Revísalo o contáctanos.",
    "fr_FR": "Code d'invitation non valide. Vérifiez le code ou contactez-nous.",
    "hi_IN": "Invalid invitation code. Please check the code or contact us.",
    "in_ID": "Kode undangan tidak valid. Periksa kode atau hubungi kami.",
    "ja_JP": "招待コードが無効です。 コードを確認するか、お問い合わせください。",
    "ko_KR": "잘못된 초대 코드입니다. 코드를 확인하거나 당사에 문의하십시오.",
    "ms_MY": "Kod jemputan tidak sah. Sila semak kod atau hubungi kami.",
    "pt_PT": "Código de convite inválido. Confira o código ou fale conosco.",
    "ru_RU": "Неверный код приглашения. Проверьте его правильность или свяжитесь с нами.",
    "th_TH": "รหัสเชิญไม่ถูกต้อง กรุณาตรวจสอบรหัสหรือติดต่อเรา",
    "tr_TR": "Geçersiz davet kodu. Lütfen kodu kontrol et veya bizimle iletişim kur.",
    "vi_VN": "Mã mời vô hiệu. Hãy kiểm tra lại mã hoặc liên hệ với chúng tôi.",
    "zh_CN": "无效邀请码，请重新检查或联系我们"
  },
  "kol_invite_code": {
    "HK": "為了確認你的身分，請輸入我們之前透過電郵或WhatsApp傳送給你的邀請碼",
    "TW": "為了確認您的身分，請輸入我們之前透過電子郵件或WhatsApp傳送給您的邀請碼",
    "ar_SA": "للتحقق من هويتك، يُرجى إدخال رمز الدعوة الذي تم إرساله إليك في السابق عبر البريد الإلكتروني أو WhatsApp.",
    "de_DE": "Um deine Identität zu verifizieren, gib bitte den Einladungscode ein, den du zuvor per Mail oder WhatsApp erhalten hast.",
    "en_US": "To verify your identity, please enter the invitation code previously sent to you via mail or WhatsApp.",
    "es_ES": "Para verificar tu identidad, ingresa el código de invitación que recibiste previamente por correo electrónico o WhatsApp.",
    "fr_FR": "Pour confirmer votre identité, saisissez le code d'invitation envoyé sur votre messagerie ou sur WhatsApp.",
    "hi_IN": "To verify your identity, please enter the invitation code previously sent to you via mail or WhatsApp.",
    "in_ID": "Untuk memverifikasi identitasmu, masukkan kode undangan yang telah dikirimkan kepadamu melalui pesan atau WhatsApp.",
    "ja_JP": "身元を確認するには、メールまたは WhatsApp で以前に送信された招待コードを入力してください。",
    "ko_KR": "신원 확인을 위해 이전에 메일 또는 WhatsApp을 통해 전송된 초대 코드를 입력하십시오.",
    "ms_MY": "Untuk mengesahkan identiti anda, sila masukkan kod jemputan yang sebelum ini dihantar kepada anda menerusi e-mel atau WhatsApp.",
    "pt_PT": "Para verificar sua identidade, insira o código de convite enviado anteriormente por e-mail ou WhatsApp.",
    "ru_RU": "Чтобы подтвердить свою личность, воспользуйтесь кодом приглашения, предварительно присланным вам по электронной почте или в WhatsApp.",
    "th_TH": "เพื่อยืนยันตัวตนของคุณ กรุณาใส่รหัสเชิญที่เราส่งให้คุณก่อนหน้านี้ผ่านทางอีเมล หรือ WhatsApp",
    "tr_TR": "Kimliğini doğrulamak için lütfen sana daha önce e-posta ya da WhatsApp üzerinden gönderilen davet kodunu gir.",
    "vi_VN": "Để xác thực danh tính của bạn, hãy nhập mã xác thực đã được gửi cho bạn trước đó qua email hoặc WhatsApp.",
    "zh_CN": "为了确认您的身份，请输入我们此前通过邮件或者Whatsapp给您发送的邀请"
  },
  "kol_keep_words": {
    "HK": "我們絕不會未經你許可，在你的頁面上發佈或更改任何內容！",
    "TW": "我們絕不會在未經您允許的情況下，在您的頁面上發佈或變更任何內容！",
    "ar_SA": "لن ننشر محتواك أو نغيره على صفحتك قط بدون موافقتك!",
    "de_DE": "Wir würden niemals etwas ohne deine Erlaubnis auf deiner Seite posten oder verändern!",
    "en_US": "We will never post or change anything on your page without your permission!",
    "es_ES": "Nunca publicaremos ni cambiaremos nada en tu página sin tu consentimiento.",
    "fr_FR": "Nous ne publierons ni ne modifierons jamais rien sur votre page sans votre autorisation !",
    "hi_IN": "We will never post or change anything on your page without your permission!",
    "in_ID": "Kami tidak akan pernah memposting atau mengubah apa pun pada halaman kamu tanpa persetujuan darimu!",
    "ja_JP": "あなたの許可なしにあなたのページに何かを投稿したり、変更したりすることは決してありません!",
    "ko_KR": "우리는 귀하의 허락 없이 귀하의 페이지에 어떤 것도 게시하거나 변경하지 않습니다!",
    "ms_MY": "Kami tidak akan membuat hantaran atau menukar apa-apa pada halaman anda tanpa kebenaran anda!",
    "pt_PT": "Nunca publicaremos ou mudaremos nada na sua página sem a sua permissão!",
    "ru_RU": "Мы никогда не публикуем и не изменяем контент на вашей странице без вашего согласия!",
    "th_TH": "เราจะไม่โพสต์หรือเปลี่ยนแปลงเนื้อหาใดๆ ในหน้าของคุณโดยที่ไม่ได้รับอนุญาตจากคุณ!",
    "tr_TR": "Rızan olmadan asla sayfanda bir şey paylaşmaz veya sayfandaki içerikleri değiştirmeyiz!",
    "vi_VN": "Chúng tôi tuyệt đối không đăng tải hoặc thay đổi nội dung trên trang của bạn nếu chưa được cho phép!",
    "zh_CN": "未经您的允许，我们绝不会在您的页面上发布或更改任何内容！"
  },
  "kol_next": {
    "HK": "下一步",
    "TW": "下一步",
    "ar_SA": "التالي",
    "de_DE": "Weiter",
    "en_US": "Next",
    "es_ES": "Siguiente",
    "fr_FR": "Suivant",
    "hi_IN": "Next",
    "in_ID": "Selanjutnya",
    "ja_JP": "次",
    "ko_KR": "다음",
    "ms_MY": "Seterusnya",
    "pt_PT": "Próximo",
    "ru_RU": "Далее",
    "th_TH": "ต่อไป",
    "tr_TR": "İleri",
    "vi_VN": "Tiếp theo",
    "zh_CN": "下一步"
  },
  "kol_notice": {
    "HK": "PUBG MOBILE俱樂部即將上線\r\n快來遊戲裏的俱樂部頁面，加入我的俱樂部吧（從大廳右下角功能表進入）\r\n現在加入還有大量遊戲福利和俱樂部內部交流賽",
    "TW": "PUBG MOBILE俱樂部即將上線\r\n快進入遊戲中的俱樂部頁面，加入我的俱樂部吧（從大廳右下角功能表進入）\r\n現在加入還有大量遊戲回饋和俱樂部內部交流賽",
    "ar_SA": "اقترب موعد نادي PUBG MOBILE.\r\nانتقل إلى قسم النادي داخل اللعبة وانضم إلى النادي الخاص بي (من القائمة أسفل اليمين في ساحة الانتظار).\r\nانضم الآن للحصول على الكثير من المزايا داخل اللعبة والوصول إلى مباريات مخصصة.",
    "de_DE": "Der PUBG MOBILE CLUB erscheint bald\r\nBeeil dich und tritt unter „CLUB“ im Spiel meinem CLUB bei (im Menü unten rechts in der Lobby). \r\nWerde jetzt Mitglied und erhalte viele Vorteile im Spiel sowie Zugang zu spielerdefinierten Matches",
    "en_US": "PUBG MOBILE CLUB will launch soon\r\nHurry and join my club from the in-game CLUB section (from the bottom-right menu in the Lobby) \r\nJoin now to receive many in-game perks and custom matches access",
    "es_ES": "PUBG MOBILE CLUB estará disponible muy pronto.\r\nDate prisa y únete a mi club en la sección de CLUB dentro del juego (en el menú en la esquina inferior derecha del Lobby). \r\nÚnete ahora para disfrutar de muchas ventajas en el juego y acceso a partidas personalizadas.",
    "fr_FR": "Le PUBG MOBILE CLUB arrive bientôt\r\nDépêchez-vous de rejoindre mon club via la section CLUB du jeu (depuis le menu dans le coin inférieur droit du salon) \r\nRejoignez-moi maintenant pour recevoir de nombreux avantages en jeu et accéder à des matchs personnalisés",
    "hi_IN": "PUBG MOBILE CLUB will launch soon\r\nHurry and join my club from the in-game CLUB section (from the bottom-right menu in the Lobby) \r\nJoin now to receive many in-game perks and custom matches access",
    "in_ID": "PUBG MOBILE CLUB akan segera diluncurkan\r\nSegera bergabung dengan klub saya dari Forum Klub dalam game (dari menu kanan bawah di Lobi)\r\nBergabunglah sekarang untuk mendapatkan berbagai manfaat dalam game dan akses Turnamen",
    "ja_JP": "PUBG MOBILE CLUBが間もなく開始されます\r\n急いで、ゲーム内の CLUB セクション (ロビーの右下のメニューから) から私のクラブに参加してください\r\n今すぐ参加して、多くのゲーム内特典とカスタム マッチへのアクセスを受け取りましょう",
    "ko_KR": "PUBG MOBILE CLUB이 곧 출시됩니다.\r\r\n게임 내 CLUB 섹션(로비 오른쪽 하단 메뉴)에서 서둘러 내 클럽에 가입하세요.\r\r\n지금 가입하여 다양한 게임 내 특전과 맞춤 매치 액세스 권한을 받으세요.",
    "ms_MY": "Kelab PUBG MOBILE hampir tiba di sini.\r\nPergi ke bahagian Kelab dalam permainan dan sertai Kelab saya (dari menu sebelah bawah kanan di Lobi).\r\nSertai sekarang untuk menerima banyak manfaat dalam permainan dan akses kepada perlawanan tersuai.",
    "pt_PT": "O PUBG MOBILE CLUB será lançado em breve\r\nCorra para entrar no meu clube na seção CLUBe no jogo (no menu inferior direito no Lobby) \r\nEntre agora para receber muitos benefícios no jogo e acesso a partidas personalizadas",
    "ru_RU": "PUBG MOBILE CLUB уже на подходе.\r\nПерейдите в игровой раздел «Клуб» и вступите в мой (меню в правом нижнем углу лобби).\r\nПрисоединяйтесь сейчас, чтобы получать многочисленные преимущества в игре и участвовать в пользовательских матчах.",
    "th_TH": "เตรียมพบกับ PUBG MOBILE คลับ\r\nไปที่คลับในเกมและเข้าร่วมคลับของฉัน (ที่เมนูบริเวณด้านล่างขวาในหน้าล็อบบี้)\r\nเข้าร่วมตอนนี้เพื่อรับสิทธิพิเศษต่างๆ ภายในเกม รวมถึงการเข้าถึงแมทช์แบบสร้างเอง",
    "tr_TR": "PUBG MOBILE Kulüp geliyor.\r\nOyun içindeki Kulüp bölümüne git ve Kulübüme katıl (Lobide sağ altta bulunan menü).\r\nPek çok oyun içi avantaj elde etmek ve özel maçlara erişmek için hemen katıl.",
    "vi_VN": "Câu Lạc Bộ PUBG MOBILE sắp ra mắt!\r\nHãy nhanh tay tham gia Câu Lạc Bộ của tôi! (Truy cập Câu Lạc Bộ trong menu dưới góc phải của Sảnh.)\r\nTham gia để nhận nhiều đặc quyền trò chơi và truy cập Trận Đấu Tùy Chỉnh!",
    "zh_CN": "PUBG MOBILE 俱乐部即将上线\r\n快来游戏里俱乐部版块加入我的俱乐部吧（从大厅右下角菜单进入）\r\n现在加入还有大量游戏福利和水友赛"
  },
  "kol_notice_1": {
    "HK": "PUBG MOBILE俱樂部即將上線",
    "TW": "PUBG MOBILE俱樂部即將上線",
    "ar_SA": "اقترب موعد الإعلان عن نادي PUBG MOBILE",
    "de_DE": "PUBG MOBILE CLUB erscheint bald",
    "en_US": "PUBG MOBILE CLUB will launch soon",
    "es_ES": "PUBG MOBILE CLUB estará disponible muy pronto",
    "fr_FR": "Le PUBG MOBILE CLUB arrive bientôt",
    "hi_IN": "PUBG MOBILE CLUB will launch soon",
    "in_ID": "PUBG MOBILE CLUB akan segera diluncurkan",
    "ja_JP": "PUBG MOBILE CLUBが間もなく開始されます",
    "ko_KR": "PUBG MOBILE CLUB이 곧 출시됩니다.",
    "ms_MY": "Kelab PUBG MOBILE hampir tiba di sini",
    "pt_PT": "O PUBG MOBILE CLUB será lançado em breve",
    "ru_RU": "PUBG MOBILE CLUB уже на подходе",
    "th_TH": "เตรียมพบกับ PUBG MOBILE คลับ",
    "tr_TR": "PUBG MOBILE Kulüp geliyor",
    "vi_VN": "Câu Lạc Bộ PUBG MOBILE sắp ra mắt!",
    "zh_CN": "PUBG MOBILE 俱乐部即将上线"
  },
  "kol_notice_2": {
    "HK": "快進入遊戲裏的俱樂部頁面加入我的俱樂部吧（從大廳右下角功能表進入）",
    "TW": "快進入遊戲中的俱樂部頁面，加入我的俱樂部吧（從大廳右下角功能表進入）",
    "ar_SA": "أسرع وانضم إلى النادي الخاص بي من قسم النادي داخل اللعبة (في القائمة السفلية اليمنى في ساحة الانتظار)!",
    "de_DE": "Beeil dich und tritt unter „Club“ im Spiel meinem Club bei (im Menü unten rechts in der Lobby)!",
    "en_US": "Hurry and join my club from the in-game CLUB section (in the bottom-right menu in the Lobby)!",
    "es_ES": "¡Date prisa y únete a mi club en la sección de CLUB dentro del juego (en el menú en la esquina inferior derecha del Lobby)!",
    "fr_FR": "Dépêchez-vous de rejoindre mon club via la section CLUB du jeu ! (menu dans le coin inférieur droit du salon)",
    "hi_IN": "Hurry and join my club from the in-game CLUB section (in the bottom-right menu in the Lobby)!",
    "in_ID": "Segera bergabung dengan klub saya dari tab KLUB dalam game (dari menu di kanan bawah di Lobi)!",
    "ja_JP": "急いで、ゲーム内の CLUB セクション (ロビーの右下のメニュー) から私のクラブに参加してください!",
    "ko_KR": "게임 내 CLUB 섹션(로비 오른쪽 하단 메뉴)에서 서둘러 내 클럽에 가입하세요!",
    "ms_MY": "Cepat dan sertai kelab saya dari bahagian KELAB dalam permainan (di bahagian bawah kanan menu di Lobi)!",
    "pt_PT": "Corra adicione meu CLUB na seção de CLUB (no menu inferior direito do Lobby)!",
    "ru_RU": "Перейдите в соответствующий раздел меню в правом нижнем углу лобби и вступите в мой клуб!",
    "th_TH": "มาที่คลับภายในเกมและเข้าร่วมคลับของฉัน (เมนูบริเวณด้านล่างขวาของหน้าล็อบบี้)!",
    "tr_TR": "Oyun içindeki KULÜP bölümüne git ve kulübüme katıl (Lobide sağ altta bulunan menü)!",
    "vi_VN": "Nhanh tay tham gia Câu Lạc Bộ của tôi! (Truy cập Câu Lạc Bộ bằng menu dưới góc phải của Sảnh.)",
    "zh_CN": "快来游戏里俱乐部版块加入我的俱乐部吧（从大厅右下角菜单进入）"
  },
  "kol_notice_3": {
    "HK": "現在加入還有大量遊戲福利和俱樂部內部交流賽",
    "TW": "現在加入還有大量遊戲回饋和俱樂部內部交流賽",
    "ar_SA": "انضم الآن للحصول على الكثير من المزايا داخل اللعبة والوصول إلى مباريات مخصصة",
    "de_DE": "Werde jetzt Mitglied und erhalte viele Vorteile im Spiel sowie Zugang zu spielerdefinierten Matches",
    "en_US": "Join now to receive many in-game perks and custom matches access",
    "es_ES": "Únete ahora para disfrutar de muchas ventajas en el juego y acceso a partidas personalizadas",
    "fr_FR": "Rejoignez-moi maintenant pour recevoir de nombreux avantages en jeu et accéder à des matchs personnalisés",
    "hi_IN": "Join now to receive many in-game perks and custom matches access",
    "in_ID": "Bergabunglah sekarang untuk mendapatkan berbagai manfaat dalam game dan akses Turnamen",
    "ja_JP": "今すぐ参加して、多くのゲーム内特典とカスタム マッチへのアクセスを受け取りましょう",
    "ko_KR": "지금 가입하여 다양한 게임 내 특전과 맞춤 매치 액세스 권한을 받으세요.",
    "ms_MY": "Sertai sekarang untuk menerima banyak manfaat dalam permainan dan akses kepada perlawanan tersuai",
    "pt_PT": "Entre agora para receber muitos benefícios no jogo e acesso a partidas personalizadas",
    "ru_RU": "Присоединяйтесь сейчас, чтобы получать многочисленные преимущества в игре и участвовать в пользовательских матчах.",
    "th_TH": "เข้าร่วมตอนนี้เพื่อรับสิทธิพิเศษต่างๆ ภายในเกม รวมถึงการเข้าถึงแมทช์แบบสร้างเอง",
    "tr_TR": "Pek çok oyun içi avantaj elde etmek ve özel maçlara erişmek için hemen katıl",
    "vi_VN": "Tham gia ngay để nhận nhiều đặc quyền trò chơi và truy cập các Trận Đấu Tùy Chỉnh.",
    "zh_CN": "现在加入还有大量游戏福利和水友赛"
  },
  "kol_ok": {
    "HK": "好",
    "TW": "好",
    "ar_SA": "موافق",
    "de_DE": "OK",
    "en_US": "OK",
    "es_ES": "Aceptar",
    "fr_FR": "OK",
    "hi_IN": "OK",
    "in_ID": "Oke",
    "ja_JP": "OK",
    "ko_KR": "좋아요",
    "ms_MY": "OK",
    "pt_PT": "OK",
    "ru_RU": "OK",
    "th_TH": "ตกลง",
    "tr_TR": "Tamam",
    "vi_VN": "Đồng ý",
    "zh_CN": "好"
  },
  "kol_pubg_id": {
    "HK": "你的PUBG MOBILE ID：",
    "TW": "您的PUBG MOBILE ID：",
    "ar_SA": "مُعرِّف PUBG MOBILE الخاص بك:",
    "de_DE": "Deine PUBG MOBILE-ID:",
    "en_US": "Your PUBG MOBILE ID:",
    "es_ES": "Tu ID de PUBG MOBILE:",
    "fr_FR": "Votre ID PUBG MOBILE :",
    "hi_IN": "Your PUBG MOBILE ID:",
    "in_ID": "ID PUBG MOBILE kamu:",
    "ja_JP": "あなたの PUBG MOBILE ID:",
    "ko_KR": "PUBG 모바일 ID:",
    "ms_MY": "ID PUBG MOBILE anda:",
    "pt_PT": "Sua ID do PUBG MOBILE:",
    "ru_RU": "Ваш ID PUBG MOBILE:",
    "th_TH": "PUBG MOBILE ID ของคุณ:",
    "tr_TR": "PUBG MOBILE Kimliğin:",
    "vi_VN": "ID PUBG MOBILE của bạn:",
    "zh_CN": "您的PUBG MOBILE ID："
  },
  "kol_save": {
    "HK": "保存",
    "TW": "儲存",
    "ar_SA": "حفظ",
    "de_DE": "Speichern",
    "en_US": "Save",
    "es_ES": "Guardar",
    "fr_FR": "Enregistrer",
    "hi_IN": "Save",
    "in_ID": "Simpan",
    "ja_JP": "保存",
    "ko_KR": "구하다",
    "ms_MY": "Simpan",
    "pt_PT": "Salvar",
    "ru_RU": "Сохранить",
    "th_TH": "บันทึก",
    "tr_TR": "Kaydet",
    "vi_VN": "Lưu",
    "zh_CN": "保存"
  },
  "kol_save_failed": {
    "HK": "綁定失敗，請重試",
    "TW": "綁定失敗，請重試",
    "ar_SA": "فشل الربط. يُرجى المحاولة مرة أخرى.",
    "de_DE": "Verbindung fehlgeschlagen, bitte erneut versuchen.",
    "en_US": "Connection failed, please try again",
    "es_ES": "Conexión fallida. Inténtalo de nuevo",
    "fr_FR": "Échec de la connexion. Veuillez réessayer.",
    "hi_IN": "Connection failed, please try again",
    "in_ID": "Penyimpanan gagal, harap coba lagi",
    "ja_JP": "接続に失敗しました。もう一度お試しください",
    "ko_KR": "연결하지 못했습니다. 다시 시도해 주세요.",
    "ms_MY": "Pautan gagal. Sila cuba lagi.",
    "pt_PT": "Falha na conexão, tente de novo",
    "ru_RU": "Ошибка привязки. Повторите попытку.",
    "th_TH": "ผูกไม่สำเร็จ กรุณาลองใหม่อีกครั้ง",
    "tr_TR": "Bağlama başarısız. Lütfen tekrar dene.",
    "vi_VN": "Liên kết thất bại. Vui lòng thử lại.",
    "zh_CN": "绑定失败，请重试"
  },
  "kol_save_id_first": {
    "HK": "請先儲存你的ID資訊",
    "TW": "請先儲存您的ID資訊",
    "ar_SA": "يُرجى حفظ معلومات المُعرِّف الخاص بك أولاً",
    "de_DE": "Bitte speichere zuerst deine ID-Informationen.",
    "en_US": "Please save your ID information first",
    "es_ES": "Guarda primero la información de tu ID",
    "fr_FR": "Enregistrez d'abord vos informations d'ID",
    "hi_IN": "Please save your ID information first",
    "in_ID": "Mohon simpan informasi ID kamu",
    "ja_JP": "最初にID情報を保存してください",
    "ko_KR": "먼저 ID 정보를 저장하십시오",
    "ms_MY": "Sila simpan maklumat ID anda dahulu",
    "pt_PT": "Salve as informações da sua ID",
    "ru_RU": "Сначала сохраните данные своего ID.",
    "th_TH": "กรุณาบันทึกข้อมูล ID ของคุณก่อน",
    "tr_TR": "Lütfen önce Kimlik bilgilerini kaydet",
    "vi_VN": "Hãy lưu thông tin ID của bạn trước",
    "zh_CN": "请先保存您的ID信息"
  },
  "kol_save_poster": {
    "HK": "儲存海報",
    "TW": "儲存海報",
    "ar_SA": "حفظ الملصق",
    "de_DE": "Speichere das Poster",
    "en_US": "Save the poster",
    "es_ES": "Guardar el póster",
    "fr_FR": "Enregistrer l'affiche",
    "hi_IN": "Save the poster",
    "in_ID": "Simpan poster",
    "ja_JP": "ポスターを保存する",
    "ko_KR": "포스터 저장",
    "ms_MY": "Simpan Poster",
    "pt_PT": "Salve o pôster",
    "ru_RU": "Сохранить плакат.",
    "th_TH": "บันทึกโปสเตอร์",
    "tr_TR": "Posteri Kaydet",
    "vi_VN": "Lưu Hình Ảnh",
    "zh_CN": "保存海报"
  },
  "kol_securely": {
    "HK": "安全地綁定你的社交頁面來排定時間和發佈內容！",
    "TW": "安全地綁定你的社群頁面來安排和發佈內容！",
    "ar_SA": "اربط حساباتك على مواقع التواصل الاجتماعي بأمان لتخطيط المحتوى ونشره!",
    "de_DE": "Verknüpfe deine Social-Media-Seiten auf sichere Weise, um Inhalte zu planen und zu veröffentlichen!",
    "en_US": "Securely connect your social pages to schedule and publish content!",
    "es_ES": "¡Conecta tus páginas de redes sociales de forma segura y publica contenido!",
    "fr_FR": "Connecter en toute sécurité vos pages de réseaux sociaux pour programmer et publier du contenu !",
    "hi_IN": "Securely connect your social pages to schedule and publish content!",
    "in_ID": "Tautkan media sosialmu dengan aman untuk merencanakan dan memposting konten!",
    "ja_JP": "ソーシャル ページを安全に接続して、コンテンツをスケジュールおよび公開します。",
    "ko_KR": "소셜 페이지를 안전하게 연결하여 콘텐츠를 예약하고 게시하세요!",
    "ms_MY": "Pautkan media sosial anda dengan selamat untuk merancang dan menyiarkan kandungan!",
    "pt_PT": "Conecte suas páginas sociais em segurança para programar e publicar conteúdo!",
    "ru_RU": "Воспользуйтесь безопасной привязкой своих социальных сетей и публикуйте контент!",
    "th_TH": "ผูกโซเชียลมีเดียของคุณอย่างปลอดภัย เพื่อวางแผนและโพสต์คอนเทนท์!",
    "tr_TR": "İçerikleri planlamak ve göndermek için sosyal medya hesabını güvenle bağla!",
    "vi_VN": "Liên kết an toàn mạng xã hội để lên kế hoạch và đăng nội dung!",
    "zh_CN": "安全地连接您的社交页面来计划和发布内容！"
  },
  "kol_select_media": {
    "HK": "請選擇綁定至少一個社交媒體帳號",
    "TW": "請選擇綁定至少一個社群媒體帳號",
    "ar_SA": "يُرجى تحديد حساب تواصل اجتماعي واحد على الأقل:",
    "de_DE": "Bitte wähle mindestens 1 Social-Media-Account aus:",
    "en_US": "Please select at least 1 social media account:",
    "es_ES": "Selecciona al menos 1 cuenta de red social:",
    "fr_FR": "Choisissez au moins 1 compte de réseau social :",
    "hi_IN": "Please select at least 1 social media account:",
    "in_ID": "Pilih minimal satu akun media sosial:",
    "ja_JP": "少なくとも 1 つのソーシャル メディア アカウントを選択してください:",
    "ko_KR": "소셜 미디어 계정을 1개 이상 선택하세요.",
    "ms_MY": "Sila pilih sekurang-kurangnya satu akaun media sosial",
    "pt_PT": "Selecione pelo menos 1 rede social:",
    "ru_RU": "Укажите как минимум одну учетную запись в соцсети:",
    "th_TH": "กรุณาเลือกบัญชีโซเชียลมีเดียอย่างน้อย 1 บัญชี:",
    "tr_TR": "Lütfen en az 1 sosyal medya hesabı seç:",
    "vi_VN": "Hãy chọn ít nhất 1 tài khoản mạng xã hội:",
    "zh_CN": "请选择绑定至少一个社媒账号"
  },
  "kol_title": {
    "HK": "PUBG MOBILE俱樂部邀請函",
    "TW": "PUBG MOBILE俱樂部邀請函",
    "ar_SA": "دعوة إلى نادي PUBG MOBILE",
    "de_DE": "PUBG MOBILE CLUB – Einladung",
    "en_US": "PUBG MOBILE CLUB Invitation Letter",
    "es_ES": "Carta de invitación a PUBG MOBILE CLUB",
    "fr_FR": "Lettre d'invitation au PUBG MOBILE CLUB",
    "hi_IN": "PUBG MOBILE CLUB Invitation Letter",
    "in_ID": "Undangan PUBG MOBILE CLUB",
    "ja_JP": "PUBG MOBILE CLUB招待状",
    "ko_KR": "PUBG MOBILE CLUB 초대장",
    "ms_MY": "Jemputan Kelab PUBG MOBILE",
    "pt_PT": "Carta de Convite do PUBG MOBILE CLUB",
    "ru_RU": "Приглашение в PUBG MOBILE CLUB",
    "th_TH": "PUBG MOBILE คำเชิญคลับ",
    "tr_TR": "PUBG MOBILE Kulüp Daveti",
    "vi_VN": "Thư Mời Câu Lạc Bộ PUBG MOBILE",
    "zh_CN": "PUBG MOBILE 俱乐部邀请函"
  },
  "kol_try_again": {
    "HK": "再試一次",
    "TW": "請再試一次",
    "ar_SA": "إعادة المحاولة",
    "de_DE": "Wiederholen",
    "en_US": "Retry",
    "es_ES": "Reintentar",
    "fr_FR": "Réessayer",
    "hi_IN": "Retry",
    "in_ID": "Coba lagi",
    "ja_JP": "リトライ",
    "ko_KR": "다시 해 보다",
    "ms_MY": "Cuba Semula",
    "pt_PT": "Tentar novamente",
    "ru_RU": "Повторить",
    "th_TH": "ลองอีกครั้ง",
    "tr_TR": "Tekrar Dene",
    "vi_VN": "Thử lại",
    "zh_CN": "再试一下"
  },
  "kol_who_is_next": {
    "HK": "下一位會是誰呢？",
    "TW": "誰會是下一位呢？",
    "ar_SA": "من التالي؟",
    "de_DE": "Wer ist der Nächste?",
    "en_US": "Who's next?",
    "es_ES": "¿Quién sigue?",
    "fr_FR": "À qui le tour ?",
    "hi_IN": "Who's next?",
    "in_ID": "Who's next?",
    "ja_JP": "次は誰だ？",
    "ko_KR": "다음 사람?",
    "ms_MY": "Siapa seterusnya?",
    "pt_PT": "Quem é o próximo?",
    "ru_RU": "Кто следующий?",
    "th_TH": "ใครคือคนต่อไป?",
    "tr_TR": "Sıradaki kim?",
    "vi_VN": "Who's next?",
    "zh_CN": "谁是下一个呢？"
  },
  "kol_your_code": {
    "HK": "你的邀請碼",
    "TW": "您的邀請碼",
    "ar_SA": "رمز دعوتك",
    "de_DE": "Dein Einladungscode",
    "en_US": "Your invitation code",
    "es_ES": "Tu código de invitación",
    "fr_FR": "Votre code d'invitation",
    "hi_IN": "Your invitation code",
    "in_ID": "Kode undanganmu",
    "ja_JP": "あなたの招待コード",
    "ko_KR": "초대 코드",
    "ms_MY": "Kod jemputan anda",
    "pt_PT": "Seu código de convite",
    "ru_RU": "Ваш код приглашения",
    "th_TH": "รหัสเชิญของคุณ",
    "tr_TR": "Davet kodun",
    "vi_VN": "Mã mời của bạn",
    "zh_CN": "您的邀请码"
  }
}